export default {
	"subscribe.MallRenewalManagementCancelSubscriptionPopupButtonClick": "商城續費管理_取消訂閱彈窗_按鈕點擊",
	"subscribe.Cancel": "取消",
	"subscribe.CancelTheContractSuccessfully": "取消簽約成功",
	"subscribe.systemError": "系統錯誤",
	"subscribe.StoreRenewalManagementRenewalEntry": "商城續費管理_續費入口",
	"subscribe.CloseRenewal": "關閉續費",
	"subscribe.ClickToTurnOffAutoRenewal": "點擊關閉自動續費",
	"subscribe.TurnOnRenewal": "開啟續費",
	"subscribe.expired": "已失效",
	"subscribe.completed": "已完成",
	"subscribe.StoreRenewalManagementUnsubscribePopup": "商城續費管理_取消訂閱彈窗",
	"subscribe.ParameterError": "參數錯誤!",
	"subscribe.subscriptionTime": "訂閱時間",
	"subscribe.nextRenewalTime": "下次續費時間",
	"subscribe.LastRenewalTime": "上次續費時間",
	"subscribe.AmountPerRenewal": "每次續費金額",
	"subscribe.Yuan": "元",
	"subscribe.WeChatPay": "微信支付",
	"subscribe.payByAliPay": "支付寶支付",
	"subscribe.AutoRenewalBenefits": "自動續費權益",
	"subscribe.saveTimeAndEnergy": "省時省力",
	"subscribe.AutomaticRenewalUponExpiration": "到期自動續費",
	"subscribe.exclusivePrivilege": "專屬特權",
	"subscribe.EnjoyPremiumContent": "尊享優質內容",
	"subscribe.124HoursBeforeTheExpirationOfEachSubscriptionTheSystemWillAutomaticallyDeductTheFeeFromTheContractedAccountAndActivateTheContentExperiencePermissionForTheNewSubscriptionCycle": "1、每次訂閱到期前24小時，系統將自動從簽約賬戶扣費，並開通新訂閱週期的內容體驗權限。",
	"subscribe.2ThereMayBeADelayInFeedbackDueToThePaymentPlatformForTheActualSubscriptionPleaseReferToTheSubscriptionRecord": "2、因支付平台問題可能存在反饋延遲問題，實際訂閱請已訂閱記錄為準。",
	"subscribe.AutomaticSubscriptionClosingPrompt": "自動訂閱關閉提示",
	"subscribe.AfterClosingTheSubscriptionTheSystemWillNotBeAbleToMakeSubsequentDeductionsAndYouWillNotBeAbleToUnlockTheCorrespondingRightsOnTimeAreYouSureYouWantToCancel": "關閉訂閱後，系統將無法進行後續的扣費，您也無法按時解鎖對應權益，是否確定取消",
	"subscribe.continueToCancel": "繼續取消",
	"subscribe.doNotCancel": "不取消"
}